import { StyleSheet } from 'aphrodite';
import { brandPrimary, darkGrayFontColor, titles, white } from '../../../styles/colors';
import { Layouts } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	onboardingCheckboxLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		fontSize: 12,
		color: darkGrayFontColor,
	},
	columns: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	container: {
		...Layouts.verticalStack(40),
	},
	radioOption: {
		color: '#858585',
		fontSize: 14,
		display: 'block',
	},
	section: {
		...Layouts.verticalStack(15),
	},
	sectionHeader: {
		color: titles,
		fontSize: 18,
		marginBottom: 10,
	},
	sectionHeaderIcon: {
		height: 20,
		width: 'auto',
	},
	recordingTypeBadge: {
		display: 'inline-flex',
		alignItems: 'center',
		padding: '6px 12px',
		borderRadius: 4,
		fontSize: 14,
		fontWeight: 600,
		backgroundColor: brandPrimary,
		color: white,
		alignSelf: 'flex-start',
	},
	// Override the container's verticalStack(40) gap for the section right after the badge
	// so the recording tag sits tight against "Meeting type" without burning vertical space.
	sectionAfterRecordingBadge: {
		marginTop: '15px !important',
	},
});
